





























import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class OportunityContent extends Vue {
  @Prop({ default: "" })
  readonly oid!: string;
  routes = [
    "Offers",
    "Cv",
    "Interviews",
    "Tests",
    "Training",
    "Networking"
  ];

  get oportunity(): any {
    return this.$store.state.selectedOportunity;
  }

  getImgUrl(icon: string) {
    const images = require.context('../assets/icons/', false, /\.png$/);
    return images('./' + this.oportunity.icon + '_60X60.png')
  }

  mounted() {
    this.$store.dispatch('bindSelectedOportunity', { oportunityId: this.oid });
  }

}
